import React, { JSX } from 'react';
import { localized } from '../../../config/localization';
import { Routes } from '../../../app/Routes';
import { BlechconOrder } from '../../../blechcon';
import { formatMeasure } from '../../../utils';
import { formatDate } from '../../../components/helper';
import { useNavigate } from 'react-router';

type Props = {
  readonly draftOrders: BlechconOrder[];
};

export function DraftListView({ draftOrders }: Props): JSX.Element {
  const navigate = useNavigate();

  return (
    <table className="table">
      <thead>
        <tr>
          <td>{localized.OFFER_ID}</td>
          <td>{localized.EMAIL}</td>
          <td>{localized.CUSTOMER_ID}</td>
          <td>{localized.CUSTOMER_REFERENCE}</td>
          <td>{localized.DATE_CREATED}</td>
          <td>{localized.STEP}</td>
          <td>{localized.MATERIAL_COST} (EUR)</td>
        </tr>
      </thead>
      <tbody>
        {draftOrders?.map((order) => {
          return (
            <tr
              key={order.id}
              onClick={() => {
                navigate(Routes.adminOrderDetails(order.id));
              }}
            >
              <td>{order.id}</td>
              <td>{order.email}</td>
              <td>{order.customerId}</td>
              <td>{order.customerReference}</td>
              <td>{formatDate(order.createdAt)}</td>
              <td>{order.checkoutStep}</td>
              <td>{order.prices.materialTotalPrice ? formatMeasure(order.prices.materialTotalPrice) : '-'}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
